import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {Menu, Dropdown, Button, Icon, message, Modal} from 'antd';
import LoginModal from '../../components/loginmodal/loginmodal';
import {bindActionCreators} from "redux"
import ReactGA from 'react-ga';
import {ga_api_key} from "../../../../../config/fbConfig"
import { signOut, signIn } from '../../../../core/actions/auth';
import $ from "jquery"
class TopNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lastScrollY: 0,
      loginForm: false,
      menuToggleIcon: false,
      mobileNav: false,
      showBlogLink: false
    };

    // this.toggleMenuIcon = this.toggleMenuIcon.bind(this)
    // this.handleMenuClick = this.handleMenuClick.bind(this);
    this.checkBlogLink = this.checkBlogLink.bind(this)
  }

  componentDidMount() {
    ReactGA.initialize(ga_api_key);
    ReactGA.pageview(window.location.pathname + window.location.search)
    this.checkBlogLink();
  
    $(window).on("scroll",()=>{
      if ($('.theme-menu-wrapper').length) {
        var sticky = $('.theme-menu-wrapper'),
            scroll = $(window).scrollTop();
        if (scroll >= 190) sticky.addClass('fixed');
        else sticky.removeClass('fixed');
      };
    })
  }
  
  componentWillMount() {
    window.scrollTo({ top: 0 });
  }

  checkBlogLink() {
    if(window.location.pathname.includes("blog")) {
      this.setState({
        showBlogLink: true
      })
    }
  }
  collapsToggle = () =>{
    const { menuToggleIcon } = this.state
    this.setState({
      menuToggleIcon: !menuToggleIcon,
    })
    if($("#navbar-collapse-1").hasClass("in")){
      $("#navbar-collapse-1").css({height:'0px'})
    setTimeout(() => {
      $("#navbar-collapse-1").removeClass("in").removeAttr('style')
    }, 300);
    }else
    {
      $("#navbar-collapse-1").addClass("in").css({height:'0px'})
      setTimeout(() => {
        $("#navbar-collapse-1").css({height:'350px'})
      }, 100);
    }
  }

  componentWillReceiveProps(nextProps) {
    var {auth,profile, localAuth} = nextProps;
    if(nextProps.toggleAction) {
      this.setState({
        loginForm: true
      });
    }
    if (localAuth.authSuccess && auth.uid && profile.isLoaded) {
      message.success(localAuth.authSuccess);
      localStorage.setItem('role', profile.role);
      localStorage.setItem('uid',auth.uid);
        window.location.reload()
      this.setState({
        mobileNav: false,
        loginForm:false,
        menuToggleIcon: false
      })
      if(this.state.menuToggleIcon) this.collapsToggle()
    }
    if (nextProps.signOutMessage) {
        message.success(nextProps.signOutMessage);
        window.location.reload()
    } 
 
  }

  showLogin = () => {
    this.setState({
      loginForm: true
    });
  }

  handleCancel = (e) => {
    this.setState({
      loginForm: false,
      mobileNav: false,
    });
    if(this.props.toggleAction) {
      this.props.toggleModal()
    }
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields((err) => {
      if (!err) {
        this.props.signIn(this.state);
      }
    });
  }
  openAffiliate=(e)=>{
    e.preventDefault()
    window.open('https://orsity.tapfiliate.com','__blank')
  }
  render() {
    const { firebase,profile } = this.props;
    const { loginForm, menuToggleIcon, mobileNav, showBlogLink } = this.state
    let iconclass = menuToggleIcon ? 'change' : ''
    let showres = mobileNav ? true : false
    // const { bgClass } = this.props || '';
    const menu = (
      <Menu onClick={e => this.handleMenuClick(e)}>
        <Menu.Item key="2"><Icon type="setting" />Settings</Menu.Item>
        <Menu.Item key="3"><Icon type="logout" />Logout</Menu.Item>
      </Menu>
    );
    const menu2 = (
      <Menu>
        <Menu.Item>
          <Link to="/blog/category/design">
            Design
          </Link>
        </Menu.Item>
      </Menu>
    );
    return (
      <header className="theme-menu-wrapper menu-style-two ">
  
				<div className="container">
					<div className="header-wrapper clearfix">
						
						<div className="logo float-left tran4s hidden-sm hidden-xs"><Link to="/"><img src="/img/newlogo.png" alt="Logo"/></Link></div>
						
						<div className="logo float-left tran4s hidden-md hidden-lg"><Link to="/"><img src="/img/newlogo.png" alt="Logo" /></Link></div>

					

						<nav className="theme-main-menu float-right navbar" id="mega-menu-wrapper">
						   <div className="navbar-header">
						   
                 <button className={`nav-mobile navbar-toggle collapsed ${iconclass}`} onClick={this.collapsToggle}>
              <div className="bar1"></div>
              <div className="bar2"></div>
              <div className="bar3"></div>
            </button>
						   </div>
						   <div className="collapse navbar-collapse" id="navbar-collapse-1" >
								<ul className="nav">
									
                  
									<li><Link to="/" className="tran3s">Home</Link></li>
									<li><Link to="/courses" className="tran3s">Courses </Link></li>
									<li><Link  to="/blog"  className="tran3s">Blog </Link></li>
									{firebase.profile.role === 'admin' &&<li><Link to="/uploadpost" className="tran3s">Upload post</Link></li>}
									{firebase.profile.role === 'admin' &&<li><Link to="/uploadcourse" className="tran3s">Upload course</Link></li>}
                  {!firebase.auth.isEmpty  &&<li><Link to="/settings" className="tran3s">Settings</Link></li>}
                  {((profile.status && profile.status.completed === false)||firebase.auth.isEmpty) && <li><Link Link to="/subscriptions" className="tran3s">Pricing </Link></li>}
                  {profile.plan ==="free" && <li><Link  to="/change-plan" className="tran3s">Go pro </Link></li>}
                  {profile.plan ==="basic" && profile.trial.plan !=="pro" && <li><Link Link to="/change-plan" className="tran3s">Go pro </Link></li>}
                  {firebase.auth.isEmpty && <li><Link  to="/pricing" className="tran3s"> Get started </Link></li>}
                  {!firebase.auth.isEmpty && <li><Link onClick={this.props.signOut} to="#" className="tran3s"> Sign out </Link></li>}
                  {firebase.auth.isEmpty && <li><Link to="#" onClick={this.showLogin} className="tran3s"> Sign in </Link></li>}
								</ul>
						   </div>
						</nav> 
					</div>
				</div>
        <Modal
            centered
            visible={loginForm}
            footer={null}
            className="x-login-modal"
            onCancel={this.handleCancel}
          >
            <div className="">
            <LoginModal 
            signIn={this.props.signIn} 
            localAuth={this.props.localAuth}/>
            </div>
          </Modal>
			</header> 
    );
  }
}


const mapStateToProps = state => ({
  firebase: state.firebase,
  signOutMessage: state.auth.signOutSuccess,
  profile: state.firebase.profile,
  localAuth: state.auth,
  auth: state.firebase.auth
});


const mapDispatchToProps = dispatch => bindActionCreators({
  signIn,
  signOut,
},dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TopNav);
